import { CardComponent } from "components";
import PieChart from "components/graphs/PieChart";
import { useEffect, useState } from "react";

const StatusCard = ({ title, value, maxValue, danger, warning, success, inactive, primary ,threshold}) => {
  const [color, setColor] = useState("");

  useEffect(() => {
    if (primary) {
      setColor("17, 125, 220");
      return;
    }

    if (inactive || maxValue === 0) {
      setColor("108, 117, 125");
      return;
    }

    if (
      danger ||
      ( threshold&& 0 <= value && value <= maxValue / 2)
    ) {
      setColor("220, 53, 69");
      return;
    }

    if (
      warning ||
      (threshold&&maxValue / 2 < value && value < maxValue)
    ) {
      setColor("255, 193, 7");
      return;
    }

    setColor("25, 135, 84");
  }, [value, maxValue]);

  const styleCard = {
    body: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      border: `1px solid rgba(${color}, 1)`,
      margin: 5,
      paddingTop: 5,
      borderRadius: 8,
      backgroundColor: `rgba(${color}, 0.2)`,
    },
    title: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      width: "100%",
      borderBottom: `1px solid rgba(${color}, 0.2)`,
      textAlign: "center",
    },
    content: {
      padding: "10px 20px 10px 20px",
    },
  };

  return (
    <div style={styleCard.body}>
      <div style={styleCard.title}>
        <h6>{title}</h6>
      </div>
      <div style={styleCard.content}>
        <h2>
          {value}/{maxValue}
        </h2>
      </div>
    </div>
  );
};

export const InfrastructureStatus = ({gnssUpUnits,gnssNoDataUnits,gnssDownUnits, gnssTotalUnits}) => {
  
  const [down, setDown] = useState(0);
  const [up, setUp] = useState(0);
  const [noData, setNoData] = useState(0);
    
  useEffect(() => {
    setDown(gnssDownUnits);
    setUp(gnssUpUnits);
    setNoData(gnssNoDataUnits);

  }, [gnssDownUnits, gnssUpUnits, gnssNoDataUnits]); // Track changes in gnssDownUnits, gnssUpUnits, and gnssNoDataUnits
  
  return (
    <>
      <CardComponent title="Infrastructure status">
        <div style={{ display: "flex", flexDirection: "row" }}>
          <StatusCard title="Down units" value={gnssDownUnits} maxValue={gnssTotalUnits} inactive />
          <StatusCard title="Runnings units" value={gnssUpUnits} maxValue={gnssTotalUnits} success />
          <StatusCard title="Requiring attention" value={gnssNoDataUnits} maxValue={gnssTotalUnits} warning/>
        </div>
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
          <PieChart width={500} height={400} dataset={{ "Down": {value:down,color:"#5a5a5a"}, "Running": {value:up,color:"#198707"}, "Warning": {value:noData,color:"#FFC107"} }} />
        </div>
      </CardComponent>
    </>
  );
};
